import { sendRequest } from '../../config';

export interface getAllAppointmentParams {
    ccita?: string;
    ccedasegurado?: string;
    identificacion?: string;
    nregistro?: string;
    xorden?: string;
    detailLocator?: string;
    cpais?: string;
    clocalizador?: string;
}

export interface dataAllAppointment {
    // Datos de la Cita / Transacción
    ccita: string;
    fcita: string; // Formato YYYYMMDDHHMMSS
    fcitap: string;
    fcitap2: string;
    fingreso: string;
    fultmod: string;
    icita: string;
    iestado: string;
    imotivo: string;
    clocalizador: string;

    // Identificación y Usuario
    ccedasegurado: string;
    ccedtitular: string;
    cusuario: string;
    cusuarioauto: string;
    cusuariomod: string;
    cusuario_toma: string;
    fnacimiento: string;
    fnacimientot: string;
    isexo: "M" | "F";
    isexot: "M" | "F";

    // Ubicación y Entidades
    cciudad: string;
    cciudadp: string;
    cpais: string;
    cclinica: string;
    cdoctor: string;
    csector: string;
    csectorp: string;
    cservicio: string;
    cciaseg: string;
    ccliente: string;

    // Información del Localizador (Objeto Anidado)
    localizador: Localizador;

    // Datos de Contacto y Nombres (Root level)
    xnombre: string;
    xapellido: string;
    xnombret: string;
    xapellidot: string;
    xemail: string;
    xtelefonocel: string;
    xtelefonohab: string;
    xdireccion: string;
    xurl: string;

    // Metadata Adicional
    xclinica: string;
    xdoctor: string;
    xdescripcion: string;
    xinfoadicional: string;
    u_version: string;
    mostrarbuzon: "T" | "F";

    // Otros campos opcionales o técnicos
    ccategoria: string;
    ccategoriaauto: string;
    ccategoriamod: string;
    itipoaseg: string;
    itiponegocio: string;
    faceptapro: string;
    fconfirmapro: string;
    ftoma_cita: string;
    ctipoecosistema: string;
    csucursal: string;
    description?: string;
}

export interface Localizador {
    nlocaliza: string;
    tlocaliza: string;
    xtlocaliza: string;
    xnomape: string;
    xnombre: string;
    xapellido: string;
    xnomcolectivo: string;
    xplan: string;
    xproducto: string;

    // Fechas de vigencia y póliza
    fdesde_pol: string;
    fhasta_pol: string;
    fencursod: string;
    fencursoh: string;
    fcontacto: string;

    // Códigos internos
    ccolectivo: string;
    cplan: string;
    cpoliza: string;
    cproducto: string;
    cpostal: string;
    czpostal: string;

    // Flags de estado (F = False, T = True)
    ienviadoacli: "T" | "F";
    ifactura: "T" | "F";
    iforanea: "T" | "F";
    ilocasig: "T" | "F";
    ipagado: "T" | "F";

    // Datos del titular
    xtitular: string;
    xtitular_ap: string;
    itipodocben: string;
    itipodoctit: string;
    nedad_t: string;

    // Otros
    xcelular: string;
    xemail: string;
    [key: string]: any; // Para campos adicionales no mapeados explícitamente
}

export const getAllAppointment = async (params: getAllAppointmentParams): Promise<dataAllAppointment[]> => {
    const ENDPOINT = 'wscita/getAll';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};